<script setup lang="ts">
  import { TabsRoot, TabsList, TabsIndicator } from 'reka-ui'
  import type { HTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'

  defineProps<{
    class?: HTMLAttributes['class']
  }>()

  const modelValue = defineModel<string>({ required: true })
</script>

<template>
  <TabsRoot v-model="modelValue">
    <TabsList
      :class="
        cn(
          'border-input relative flex items-center gap-1 border-b',
          $props.class
        )
      "
    >
      <slot />
      <TabsIndicator
        class="bg-primary absolute -bottom-px left-0 h-0.5 rounded-full transition-[width,transform] duration-200 ease-out"
        :style="{
          width: 'var(--reka-tabs-indicator-size)',
          transform: 'translateX(var(--reka-tabs-indicator-position))'
        }"
      />
    </TabsList>
  </TabsRoot>
</template>
